import { LOGO } from "@/data/config";

// Renders the official Maison Core logo via CSS mask so it can be filled with
// exact brand colors (Onyx / Petal) on any background — artwork & proportions
// are preserved from the original file (the alpha channel is used as the mask).
export function Logo({ color = "#280B03", className = "h-9 w-[150px] md:h-11 md:w-[190px]" }) {
  return (
    <span
      role="img"
      aria-label="Maison Core — Reformer Studio"
      className={`block transition-colors duration-500 ${className}`}
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url(${LOGO})`,
        maskImage: `url(${LOGO})`,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "left center",
        maskPosition: "left center",
        WebkitMaskSize: "auto 100%",
        maskSize: "auto 100%",
      }}
    />
  );
}
